import { SchemaFormDefinition } from '@mews-commander/form';
import { lt } from '@mews/framework';
import { ResourceCategoryField, ServiceIdField } from '../common';
import { schema } from './schema';

const commonDefinition = {
    fields: {
        name: {
            label: lt('IntegrationName'),
        },
        resourceCategoryIds: {
            label: lt('ResourceCategoryPlural'),
            helper: lt('EnterpriseIntegrationSettingsIncludedSpaceCategoriesHelper'),
            render: (props, { fieldNames }) => (
                <ResourceCategoryField serviceIdFieldName={fieldNames.serviceId} {...props} multiselect />
            ),
        },
        serviceId: {
            label: lt('Service'),
            render: (props) => <ServiceIdField {...props} />,
        },
        enterpriseCode: {
            label: lt('PropertyCode'),
            required: true,
        },
        receiverEmails: {
            label: lt('ReceiverEmails'),
            helper: lt('EnterpriseIntegrationSettingsSemicolonToSeparate'),
            required: true,
        },
        dailyReportExecutionTime: {
            label: lt('DailyReportExecutionTime'),
            field: { type: 'time', mode: 'iso' },
        },
        notes: {
            label: lt('Notes'),
            field: { type: 'textarea' },
        },
    },
    renderFields: [
        'name',
        'serviceId',
        'resourceCategoryIds',
        'enterpriseCode',
        'receiverEmails',
        'dailyReportExecutionTime',
        'notes',
    ],
} satisfies SchemaFormDefinition<typeof schema>;

export const formDefinition = {
    fields: commonDefinition.fields,
    renderFields: commonDefinition.renderFields,
} satisfies SchemaFormDefinition<typeof schema>;

export const updateFormDefinition = {
    fields: {
        ...commonDefinition.fields,
        serviceId: {
            label: lt('Service'),
            render: (props) => <ServiceIdField {...props} />,
            readOnly: true,
        },
    },
    renderFields: commonDefinition.renderFields,
} satisfies SchemaFormDefinition<typeof schema>;
